import { useId, useState } from "react";
import {
  Edit,
  Eye,
  Preview,
  ShareIcon,
} from "../../../../components/styled/AllImages";
import {
  Box,
  ButtonStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../context/userContext";
import { toast } from "react-toastify";
import ShareModal from "../../../../components/auth/Modal/ShareProfileModal";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import {
  buildProfilePath,
  isValidProfileUsername,
} from "../../../../utils/profileUsername";
const WEBSITE_BASE_URL = process.env.REACT_APP_WEBSITE_URL;

const BannerImage = ({ username }) => {
  const { user } = useUser();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    user?.cover ? resolveMediaUrl(user?.cover) : null
  );
  const uniqueId = useId();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedImage(fileURL);
    }
  };

  const profilePath = buildProfilePath(username);
  const profileUrl = profilePath ? `${WEBSITE_BASE_URL}${profilePath}` : null;

  const shareProfile = async () => {
    if (!profileUrl) {
      toast.error(t("profile_not_found"));
      return;
    }

    try {
      await navigator.clipboard.writeText(profileUrl);

      toast.success(t("url_copied_successfully"), {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    } catch (err) {}
  };

  const openShareModal = () => {
    if (!isValidProfileUsername(username)) {
      toast.error(t("profile_not_found"));
      return;
    }

    setShowModal(true);
  };

  const openProfilePreview = () => {
    if (!profilePath) {
      toast.error(t("profile_not_found"));
      return;
    }

    window.open(profilePath, "_blank");
  };

  return (
    <Box className="bannerImg">
      {selectedImage && <img src={selectedImage} />}
      <Box className="icons-wrapper">
        <SpanStyled
          className="px-3 py-2 bg-white rounded-2"
          style={{
            cursor: "pointer",
          }}
          onClick={openShareModal}
          title={t("share_profile")}
        >
          <ShareIcon />
        </SpanStyled>
        <SpanStyled
          className="px-3 py-2 bg-white rounded-2"
          style={{
            cursor: "pointer",
            color: "#798caf",
          }}
          onClick={openProfilePreview}
          title={t("preview_profile")}
        >
          <Preview />
        </SpanStyled>
      </Box>
      <SpanStyled
        className=" share-icon-my-profile px-3 py-2 bg-white rounded-2"
        style={{
          cursor: "pointer",
        }}
        onClick={openShareModal}
        title={t("share_profile")}
      >
        <ShareIcon />
      </SpanStyled>
      <SpanStyled
        className="preview-icon px-3 py-2 bg-white rounded-2"
        style={{
          cursor: "pointer",
          color: "#798caf",
        }}
        onClick={openProfilePreview}
        title={t("preview_profile")}
      >
        <Preview />
      </SpanStyled>

      {/* <Box className="editBanner">
        <ButtonStyled
          // onClick={() => document.getElementById(`imageInput-${uniqueId}`).click()}
          onClick={() => navigate("/profile")}
          label={t("edit_profile")}
          icon={Edit}
          bg="var(--white)"
          color="var(--darkGrey)"
          padding="8px 18px"
          size="14px"
        />
      </Box> */}
      <input
        id={`imageInput-${uniqueId}`}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <ShareModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        cardLink={profileUrl || ""}
      />
    </Box>
  );
};
export default BannerImage;

